<ng-container *transloco="let t">
	<div class="text-hl-l text-headline">
		{{
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.subComponents.addressValidator.headlines.title'
			)
		}}
	</div>
	<div class="mt-s mb-s">
		{{
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.subComponents.addressValidator.texts.description'
			)
		}}
	</div>

	<form [formGroup]="addressSelectionForm">
		<label
			*ngFor="let address of config.data?.['addressSuggestions']"
			class="flex items-start py-m cursor-pointer border-inactive border-b"
		>
			<input type="radio" class="hidden" [value]="address" formControlName="selected" />
			<input type="radio" class="pointer-events-none mt-2xs" [checked]="isSelected(address)" />
			<div class="ml-m flex flex-col">
				<span beyond-online-text>{{ address?.address.freeformAddress }}</span>
			</div>
		</label>
		<div class="flex flex-col">
			<button
				type="button"
				beyond-online-button
				class="w-full mt-l mb-s justify-center"
				variant="primary"
				name="accept"
				[label]="
					t(
						'generalComponents.addressSelector.subComponents.customerAddress.subComponents.addressValidator.buttons.accept'
					)
				"
				(click)="acceptAddressSuggestion()"
			></button>
			<button
				type="button"
				name="cancel"
				beyond-online-button
				class="w-full justify-center"
				variant="secondary"
				[label]="
					t(
						'generalComponents.addressSelector.subComponents.customerAddress.subComponents.addressValidator.buttons.cancel'
					)
				"
				(click)="cancel()"
			></button>
		</div>
	</form>
</ng-container>
